module.exports = __webpack_public_path__ + "static/media/irregular_prism.ef5e8d89.svg";